<template>
    <div id="moduleAppList">
        <div class="top">
             <location-selector hasProvinceAll hasCityAll @change="getList()"
                               v-model="locationArray"></location-selector>
            <el-select size="medium" @change="getList()" v-model="subBranchCode" placeholder="请选择"
                       style="width:120px">
                <el-option label="全部支行" :value="''"></el-option>
                <el-option v-for="dealerItem in dealerList" :label="dealerItem.value"
                           :value="dealerItem.code"></el-option>
            </el-select>
            <el-select size="medium" @change="getList()" v-model="type" placeholder="请选择" style="width:140px">
                <el-option label="全部学校类型" :value="0"></el-option>
                <el-option v-for="[value, label] in schoolTypeConstants" :label="label"
                           :value="value"></el-option>
            </el-select>
            <el-button v-if="isShowByPermission('/wyms/school/insertSchool')" size="medium" type="primary" @click="jumpToPage('schoolAdd')">新增学校</el-button>
            <el-button style="margin-left: 0;" v-if="isShowByPermission('/wyms/school/deleteSchool')" size="medium" type="danger" @click="batchDeleteHandler">删除</el-button>
            <a
                :href="exportHref"
                target="_blank"
                download="学校列表"
            >
                <el-button
                    type="primary"
                    size="medium"
                >导出
                </el-button>
            </a>
            <el-input style="margin-left: 4px;" size="medium" class="search-input search-input--right" placeholder="责任人"
                      v-model="liableNames" @keyup.enter.native="getList">
                <el-button slot="append" icon="el-icon-search" size="medium" @click="getList"></el-button>
            </el-input>
            <el-input size="medium" class="search-input search-input--right" placeholder="学校名称/id/cropid"
                      v-model="searchVal" @keyup.enter.native="getList">
                <el-button slot="append" icon="el-icon-search" size="medium" @click="getList"></el-button>
            </el-input>
        </div>
        <div>
            <el-table
                :height="windowHeight - 245"
                :data="dataList"
                style="width: 100%" border
                @selection-change="handleSelectionChange"
            >
                <el-table-column
                    type="selection"
                    width="55">
                </el-table-column>
                <el-table-column
                    label="id"
                    prop="id"
                    align="center"
                    width="70"
                >
                </el-table-column>
                <el-table-column
                    label="学校名称"
                    align="center" show-overflow-tooltip
                    width="350px"
                >
                    <template slot-scope="scope">
                         <span class="link" @click="jumpToPage('schoolDetail', {schoolId: scope.row.id})">
                        {{ scope.row.name }}
                         </span>
                    </template>

                </el-table-column>
                <el-table-column
                    label="类型" show-overflow-tooltip
                    align="center"
                >
                    <template slot-scope="scope">
                        <span>{{parseToConstants(scope.row.type, 'schoolTypeConstants')}}</span>
                    </template>
                </el-table-column>
                <el-table-column
                    label="区域"
                    width="200px"
                    align="center" show-overflow-tooltip
                    prop="orgAreaName"
                >
                </el-table-column>
                <el-table-column
                    label="客户经理" show-overflow-tooltip
                    align="center"
                >
                    <template slot-scope="scope">
                        <span>{{scope.row.customerManager}}</span>
                    </template>
                </el-table-column>
                <el-table-column
                    label="来源" show-overflow-tooltip
                    align="center"
                    prop="guestSource"
                >
                </el-table-column>

                <el-table-column
                    label="所属支行" show-overflow-tooltip
                    align="center"
                >
                    <template slot-scope="scope">
                        <span>{{scope.row.subBranch}}</span>
                    </template>
                </el-table-column>

                <el-table-column
                    label="责任人" show-overflow-tooltip
                    align="center"
                >
                    <template slot-scope="scope">
                        <span>{{scope.row.liableNames}}</span>
                    </template>
                </el-table-column>
                <el-table-column width="140"
                                 label="操作"
                                 align="center"
                >
                    <template slot-scope="scope">
                        <el-button type="text" size="small" v-if="isShowByPermission('/wyms/school/redirectLoginZ')" @click="loginSchool(scope.row.id)">登录</el-button>
                        <el-button type="text" size="small" v-if="isShowByPermission('/wyms/school/updateCheckSchool') && scope.row.isDelete == 3"
                                   @click="reviewSchoolFunc(scope.row)">审核
                        </el-button>
                        <el-button type="text" size="small" v-if="isShowByPermission('/wyms/school/updateState') && scope.row.isDelete == 1"
                                   @click="updateStateFunc(false, scope.row.id)">禁用
                        </el-button>
                        <el-button type="text" size="small" v-else-if="isShowByPermission('/wyms/school/updateState') && scope.row.isDelete == 4"
                                   @click="updateStateFunc(true, scope.row.id)">开启
                        </el-button>
                        <el-button type="text" size="small" @click="deleteHandler(scope.row.id)" v-if="isShowByPermission('/wyms/school/deleteSchool')">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="state-container">
                <el-radio-group v-model="isDelete" @change="changeState()">
                    <el-radio :label="0">全部</el-radio>
                    <el-radio :label="3">待审核</el-radio>
                    <el-radio :label="1">运行中</el-radio>
                    <el-radio :label="4">禁用</el-radio>
                </el-radio-group>
            </div>
            <div class="pagination-container">
                <el-pagination
                    @size-change="sizeChangeHandler"
                    @current-change="currentChangeHandler"
                    :current-page.sync="pagination.pageNo"
                    :page-sizes="[10 , 20, 30, 50]"
                    :page-size.sync="pagination.pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :page-count="pagination.pages"
                    :total="pagination.total"
                >
                </el-pagination>
            </div>
            <el-dialog title="审核" :visible.sync="isShowReviewDialog" :close-on-press-escape='false'
                       width="600px"
                       :lock-scroll="false"
                       :close-on-click-modal='false' :modal-append-to-body='false'>
                <div>
                    <el-form :model="reviewForm"
                             label-width="120px">
                        <el-form-item label="是否新家校模式">
                            <el-checkbox v-model.trim="reviewForm.externalContact" :true-label="2"
                                         :false-label="1"></el-checkbox>
                        </el-form-item>
                        <el-form-item label="学校类型">
                            <el-select size="medium" v-model="reviewForm.schoolType" placeholder="请选择"
                                       style="width:120px">
                                <el-option v-for="[value, label] in schoolTypeConstants" :label="label"
                                           :value="value"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="所属区域">
                            <location-selector v-model="reviewForm.locationArray" :hasDistAll="false"
                                               ref="reviewLocationSelector"></location-selector>
                        </el-form-item>
                    </el-form>
                </div>
                <span slot="footer" class="dialog-footer">
                <el-button size="medium" @click="isShowReviewDialog = false">取 消</el-button>
                <el-button size="medium" type="primary" @click="reviewSchoolConfirm()">确定</el-button>
            </span>
            </el-dialog>
        </div>
    </div>
</template>

<script>
    import LocationSelector from '@/components/LocationSelector';
    import {schoolTypeConstants} from '@/utils/constants';
    import {getExportUrl, isShowByRoleList, parseToConstants, isShowByPermission} from '@/utils/utils';
     import {findDicsByCode} from "@/api/foodSetting";
    import windowResize from '@/mixins/windowResize';
    import baseMixin from '@/mixins/baseMixin';
    import {getAllDealerManageList} from '@/api/dealerManage';
    import {
        querySchoolList,
        deleteSchool,
        updateState,
        updateCheckSchool
    } from '@/api/schoolManage';

    export default {
        name: 'schoolListAbc',
        data() {
            return {
                searchVal: '',
                liableNames: '',
                clientType: 2,
                interfaceState: 1,

                dataList: [],
                multipleSelection: [],
                locationArray: ['320000', '0', '0'],
                type: 0,
                subBranchCode: '',
                dealerList: [],
                isDelete: 1,
                schoolTypeConstants,

                isShowReviewDialog: false,
                reviewSchoolId: null,
                reviewForm: {
                    externalContact: 1,
                    schoolType: '1',
                    locationArray: ['320000', '320100', '320102']
                }
            }
        },
        computed: {
            exportHref() {
                let orgAreaCode = '';
                orgAreaCode = this.locationArray[2] == '0' ? (this.locationArray[1] == '0' ? (this.locationArray[0] == '' ? '' : this.locationArray[0]) : this.locationArray[1]) : this.locationArray[2]

                return getExportUrl('/school/exportSchoolList', {
                    subBranchCode: this.subBranchCode,
                    isDelete: this.isDelete,
                    orgAreaCode: orgAreaCode == 0 ? '' : orgAreaCode,
                    searchVal: this.searchVal,
                    type: this.type,
                    liableNames: this.liableNames,
                    clientType: this.clientType
                }, global.command === "production"
                    ? "https://wyms.weixiaojia.cn/wyms"
                    : "https://wyms.weixiaojia.net/wyms");
            },
        },
        filters: {
            timeFormat(time) {
                return time ? time.substring(0, 19) : ''
            }
        },
        components: {LocationSelector},
        created() {
            // getAllDealerManageList()
            //     .then(data => {
            //         this.dealerList = data;
            //     });
             findDicsByCode('subBranch').then(res=>{                
                this.dealerList=res.data.data;            
            }).catch();
            this.querySchoolListFunc()
        },
        beforeRouteEnter(to, from, next) {
            next(vm => {
                vm.querySchoolListFunc()
            });
        },
        mixins: [windowResize, baseMixin],
        methods: {
            isShowByPermission,
            parseToConstants,
            isShowByRoleList,
            loginSchool(schoolId) {
                const link = (global.command === 'production' ? 'https://wyms.weixiaojia.cn/wyms' : 'http://wyms.weixiaojia.net/wyms') + '/school/redirectLogin?token=' + this.$store.getters.token + '&schoolId=' + schoolId;
                window.open(link, '_blank');
            },
            reviewSchoolFunc(schoolItem) {
                this.reviewSchoolId = schoolItem.id;
                this.reviewForm = {
                    externalContact: 1,
                    schoolType: schoolItem.type.toString(),
                    locationArray: schoolItem.areaCode ?
                        [`${schoolItem.areaCode.slice(0, 2)}0000`, `${schoolItem.areaCode.slice(0, 4)}00`, schoolItem.areaCode] :
                        ['320000', '320100', '320102']
                };

                this.isShowReviewDialog = true;
            },
            reviewSchoolConfirm() {
                const args = {
                    schoolId: this.reviewSchoolId,
                    externalContact: this.reviewForm.externalContact,
                    orgAreaName: this.$refs.reviewLocationSelector.getNameArray().join(' '),
                    orgAreaCode: this.reviewForm.locationArray.join(','),
                    areaCode: this.reviewForm.locationArray[2],
                    schoolType: this.reviewForm.schoolType
                };
                updateCheckSchool(args)
                    .then(res => res.data)
                    .then(data => {
                        if (data.result) {
                            this.$message.success('审核成功');
                            this.isShowReviewDialog = false;
                            this.getList();
                        } else if (data.code == 1005) {
                            this.$confirm(data.msg, '提示', {
                                confirmButtonText: '确定',
                                cancelButtonText: '取消',
                                type: 'warning',
                                lockScroll: false
                            }).then(() => {
                                args.confirm = true;
                                updateCheckSchool(args)
                                    .then(res => res.data)
                                    .then(data => {
                                        if (data.result) {
                                            this.$message.success('审核成功');
                                            this.isShowReviewDialog = false;
                                            this.getList();
                                        } else {
                                            this.$message(data.msg);
                                        }
                                    });
                            });
                        }

                    })
            },
            updateStateFunc(isOn, schoolIds) {
                this.$confirm(`确认要${isOn ? '开启' : '禁用'}吗？`, isOn ? '开启' : '禁用', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning',
                    lockScroll: false
                }).then(() => {
                    updateState({
                        schoolIds,
                        usedState: isOn ? 1 : 4
                    })
                        .then(() => {
                            this.querySchoolListFunc();
                        })
                });
            },
            changeState() {
                this.locationArray = ['0', '0', '0'];
                this.getList();
            },
            getList() {
                this.pagination.pageNo = 1;
                setTimeout(() => {
                    this.querySchoolListFunc();
                }, 100);
            },
            handleSelectionChange(val) {
                this.multipleSelection = val;
            },
            sizeChangeHandler() {
                this.querySchoolListFunc();
            },
            currentChangeHandler() {
                this.querySchoolListFunc();
            },
            batchDeleteHandler() {
                if (this.multipleSelection.length === 0) {
                    this.$message.error('请选择要删除的角色');
                } else {
                    this.deleteHandler(this.multipleSelection.map(({id}) => id).join(','));
                }
            },
            deleteHandler(schoolIds) {
                this.$confirm('确认要删除吗？', '删除', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning',
                    lockScroll: false
                }).then(() => {
                    deleteSchool({
                        schoolIds
                    })
                        .then(() => {
                            this.querySchoolListFunc();
                        })
                });
            },
            querySchoolListFunc() {
                let orgAreaCode = '';
                orgAreaCode = this.locationArray[2] == '0' ? (this.locationArray[1] == '0' ? (this.locationArray[0] == '' ? '' : this.locationArray[0]) : this.locationArray[1]) : this.locationArray[2]

                querySchoolList({
                     subBranchCode: this.subBranchCode,
                    isDelete: this.isDelete,
                    orgAreaCode: orgAreaCode == 0 ? '' : orgAreaCode,
                    searchVal: this.searchVal,
                    type: this.type,
                    pageNo: this.pagination.pageNo,
                    pageSize: this.pagination.pageSize,
                    liableNames: this.liableNames,
                    clientType: this.clientType,
                    interfaceState: (this.clientType == 1 || this.clientType == 12 || this.clientType == 4) ? this.interfaceState : 0,
                })
                    .then(data => {
                        this.dataList = data.dataList;
                        this.pagination.total = data.pagination.total;
                    })
            }
        }
    }
</script>
<style>
    #moduleAppList .el-select {
        width: 120px;
    }
</style>
<style lang="scss" scoped>
    #moduleAppList {
        padding: 12px;

        .pagination-container {
            margin-top: 10px;
        }

        .top {
            padding-bottom: 10px;
            overflow: hidden;

        }

        a, .link {
            color: #409EFF;
            cursor: pointer;
        }

        .state-container {
            margin: 15px 0;
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/schoolManage/schoolListAbc.vue